function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M15.992 1.6c0-.88-.712-1.6-1.592-1.6H1.6C.72 0 0 .72 0 1.6v9.6c0 .88.72 1.6 1.6 1.6h11.2L16 16l-.008-14.4zm-3.192 8H3.2V8h9.6v1.6zm0-2.4H3.2V5.6h9.6v1.6zm0-2.4H3.2V3.2h9.6v1.6z",
  id: "contact_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "contact_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#contact_svg__a"
})), React.createElement("use", {
  fill: "currentColor",
  fillRule: "nonzero",
  xlinkHref: "#contact_svg__a"
}), React.createElement("g", {
  mask: "url(#contact_svg__b)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M0 0h20v20H0z"
})));

var Contact = function Contact(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default Contact;